export interface ColReqStatusEnum {
  value: number
  name: string
  i18nKey: string
}

export const colReqStatusEnum: ColReqStatusEnum[] = [
  { value: 0, name: "UNKNOWN", i18nKey: "entity.collection_request.status.unknown" },
  { value: 1, name: "CREATED", i18nKey: "entity.collection_request.status.created" },
  { value: 2, name: "SENT", i18nKey: "entity.collection_request.status.sent" },
  { value: 3, name: "FAILED_TO_SEND", i18nKey: "entity.collection_request.status.failed_to_send" },
  { value: 1001, name: "ASSIGNED", i18nKey: "entity.collection_request.status.assigned" },
  { value: 1002, name: "SCAN_RECORDED", i18nKey: "entity.collection_request.status.scan_recorded" },
  { value: 1003, name: "CANCELLED", i18nKey: "entity.collection_request.status.cancelled" },
  { value: 1004, name: "FAILED", i18nKey: "entity.collection_request.status.failed" },
  { value: 1005, name: "CANCEL_NOT_POSSIBLE", i18nKey: "entity.collection_request.status.cancel_not_possible" },
  { value: 1006, name: "REJECTED", i18nKey: "entity.collection_request.status.rejected" }
]
